<template>
  <div class="villa-splash" :class="{ 'villa-splash--leaving': leaving }">
    <div class="villa-splash__inner">
      <VillaLogo
        variant="full"
        :size="56"
        animated
        class="villa-splash__logo"
      />
    </div>
  </div>
</template>

<script>
import VillaLogo from "@/components/VillaLogo.vue";

export default {
  name: "SplashScreen",
  components: { VillaLogo },
  props: {
    // Durata totale (ms) prima di emettere "finished"
    duration: {
      type: Number,
      default: 1800,
    },
  },
  emits: ["finished"],
  data() {
    return {
      leaving: false,
      timers: [],
    };
  },
  mounted() {
    const fadeMs = 450;
    // Avvia il fade-out poco prima della fine
    this.timers.push(
      setTimeout(() => {
        this.leaving = true;
      }, Math.max(0, this.duration - fadeMs))
    );
    // Notifica il termine: il parent può smontare lo splash
    this.timers.push(
      setTimeout(() => {
        this.$emit("finished");
      }, this.duration)
    );
  },
  beforeUnmount() {
    this.timers.forEach(clearTimeout);
  },
};
</script>

<style scoped>
.villa-splash {
  /* Card centrata della stessa misura del form di login (#login-form):
     max-width 380px, padding/raggio/ombra identici. Così, quando lo splash
     svanisce, rivela il login nello stesso punto -> transizione fluida. */
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 48px);
  max-width: 458px;
  height: 305.5px;
  box-sizing: border-box;
  padding: 40px 36px;
  background: var(--villa-white, #fff);
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  opacity: 1;
  transition: opacity 0.45s ease;
  top: 52%;
}

.villa-splash--leaving {
  opacity: 0;
  pointer-events: none;
}

.villa-splash__inner {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Wordmark: appare dopo il tetto, con leggero slide/fade */
.villa-splash__logo :deep(.villa-logo__word) {
  opacity: 0;
  animation: villa-word-in 0.6s ease-out 0.55s forwards;
}

/* Glow soft sul tetto dopo il disegno */
.villa-splash__logo :deep(.villa-logo__roof) {
  animation: villa-roof-glow 0.9s ease-in-out 1s 1;
}

@keyframes villa-word-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes villa-roof-glow {
  0% {
    filter: drop-shadow(0 0 0 rgba(47, 111, 174, 0));
  }
  50% {
    filter: drop-shadow(0 0 10px rgba(47, 111, 174, 0.55));
  }
  100% {
    filter: drop-shadow(0 0 0 rgba(47, 111, 174, 0));
  }
}

@media (prefers-reduced-motion: reduce) {
  .villa-splash__logo :deep(.villa-logo__word) {
    opacity: 1;
    animation: none;
  }
  .villa-splash__logo :deep(.villa-logo__roof) {
    animation: none;
  }
}
</style>
